import $ from 'jquery';

const closeMessage = function(message, showNext) {
    message.remove();

    if(showNext){
        var messageId = message.attr("data-id");
        var messagePublishDate = message.attr("data-publish-date");
        var messageEndDate = message.attr("data-end-date");

        window.localStorage.setItem("message_" + messageId + "_" + messagePublishDate, messageEndDate);
        cleanOldMessageEntries();
        showFirstEligibleMessage();
    }
};

const bindCloseMessageEvent = function(){
    // close button on the service message from a list
    $(document).on('click','aside.service-message-list > div.dcw_alert-message_wrapper > button.dcw_alert-message_close-btn',function() {
        closeMessage($(this).parents("aside.dcw_alert-message"), true);
    });

    // close button on a unique service message
    $(document).on('click','aside.service-message-instance > div.dcw_alert-message_wrapper > button.dcw_alert-message_close-btn',function() {
        closeMessage($(this).parents("aside.dcw_alert-message"), false);
    });
};


const showFirstEligibleMessage = function(){
	
	// Remove invalid messages (out of date or closed by user)
    $("aside.dcw_alert-message.service-message-list").each(function(index, element) {
        var message = $(element);

        // By default all message are not displayed
        // Check if currentTimeStamp is after messageStartDate and less than messageEndDate
		var messageok=false;
        var currentTimeStamp = Math.round(new Date().getTime());
        var messageStartDate = message.attr("data-start-date");
        var messageEndDate = message.attr("data-end-date");
        if ((messageEndDate > currentTimeStamp) && (messageStartDate < currentTimeStamp)) {
            // If there is no info regarding this message on the localStorage, then it means the user didn't close it yet
			var messageId = message.attr("data-id");
			var messagePublishDate = message.attr("data-publish-date");
			
            if (window.localStorage.getItem("message_" + messageId + "_" + messagePublishDate) == undefined){
				messageok=true;
            }
        }
		if (!messageok) {
		    message.remove();
		}
    });

	// Show first n messages
    $("aside.dcw_alert-message.service-message-list").each(function(index, element) {
        var message = $(element);

		// Show first n messages : 
		// if not displayed yet : unwrap and set as displayed
		// else leave as is.
        var messageItemsDisplayed = message.attr("itemsdisplayed");
		if (messageItemsDisplayed) {} else messageItemsDisplayed = 1;
		if (index < messageItemsDisplayed) {
			
			var margin_top = (index>0) ? "1rem" : "0";
			message.css("margin-top", margin_top);

			if (message.attr("displayed")) {}
			else {
				message.attr("displayed", "true");
				message.unwrap();
			}
		}	
		else
			return false;
    });
};

const cleanOldMessageEntries = function() {
    var localStorageKeys = Object.keys(window.localStorage);
    var currentDate = new Date().valueOf();
    var key;

    for(var i = 0; i < localStorageKeys.length; i++){
        key = localStorageKeys[i];

        // if the key starts with "message_", then it's from our Service Messages implementation; and if its value (end date)
        // is lower then the current date, then it means the end date has expired, so the message is not in the HTML already,
        // so we can remove it from the localStorage
        if(key.startsWith("message_") && window.localStorage.getItem(key) < currentDate){
            window.localStorage.removeItem(key);
        }
    }
};

export {bindCloseMessageEvent};
export {showFirstEligibleMessage};


// WEBPACK FOOTER //
// ./src/js/cms/commons/service-messages.js